import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken, setToken } from '@/utils/auth'
import router from '@/router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 300000,
  withCredentials: true // 携带cookie，保证session一致
})

// request interceptor
service.interceptors.request.use(
  config => {
    const token = getToken() || localStorage.getItem('token') || sessionStorage.getItem('token')
    if (token) {
      const t = token.startsWith('Bearer ') ? token : `Bearer ${token}`
      config.headers['Authorization'] = t
    }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    // 检查是否是blob响应（文件下载）
    if (response.config.responseType === 'blob') {
      console.log('Response interceptor - blob response detected')
      console.log('Response interceptor - blob response status:', response.status)
      // 检查响应状态，如果不是成功状态，需要特殊处理
      if (response.status >= 200 && response.status < 300) {
        // 对于成功的blob响应，直接返回原始response对象
        return response
      } else {
        // 对于错误的blob响应，需要读取内容并抛出错误
        console.log('Response interceptor - blob response error, status:', response.status)
        return response.blob().then(blob => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = function() {
              const text = reader.result
              console.log('Response interceptor - error blob content:', text)
              // 尝试解析为JSON错误响应
              try {
                const errorData = JSON.parse(text)
                reject(new Error(errorData.msg || '请求失败'))
              } catch (e) {
                reject(new Error(text || '请求失败'))
              }
            }
            reader.readAsText(blob)
          })
        })
      }
    }

    const res = response.data
    console.log('Response interceptor - raw response:', response)
    console.log('Response interceptor - response.data:', res)

    // 检查响应头中是否有新的token
    const newToken = response.headers['authorization']
    if (newToken) {
      console.log('收到新的token，正在更新...')
      const tokenToStore = newToken.startsWith('Bearer ') ? newToken : `Bearer ${newToken}`
      setToken(tokenToStore)
      store.commit('user/SET_TOKEN', tokenToStore)
      try { localStorage.setItem('token', tokenToStore) } catch (e) {}
    }

    return res
  },
  error => {
    console.error('Response interceptor - error:', error)
    const { response } = error
    if (response) {
      // 后端返回了错误响应
      const { status, data } = response
      console.error(`Error: ${status}, Message: ${data.msg}`)
      handleErrorResponse(status, data.msg) // 处理错误
    } else {
      // 网络错误或其他问题
      console.error('Network Error')
      handleErrorResponse(500, '网络连接失败，请稍后再试')
    }
    return Promise.reject(error)
  }
)

// 错误处理函数
function handleErrorResponse(status, message) {
  switch (status) {
    case 401:
      Message({
        message: '登录已过期，请重新登录',
        type: 'error',
        duration: 5 * 1000
      })
      // 清除token并跳转到登录页
      store.dispatch('user/resetToken').then(() => {
        location.reload()
      })
      break
    case 403:
      Message({
        message: '您没有权限访问该资源',
        type: 'error',
        duration: 5 * 1000
      })
      break
    case 404:
      Message({
        message: '请求的资源不存在',
        type: 'error',
        duration: 5 * 1000
      })
      break
    default:
      Message({
        message: message || '发生未知错误',
        type: 'error',
        duration: 5 * 1000
      })
  }
}

export default service
